<div ngbAccordion #accordion="ngbAccordion">
	<div [ngbAccordionItem]="header()" [collapsed]="false" [destroyOnHide]="true">
		<div ngbAccordionHeader>
			<button ngbAccordionButton class="common-collapse-btn-header btn btn-flat p-2 m-0">{{header()}}
			</button>
		</div>
		<div ngbAccordionCollapse>
			<div ngbAccordionBody class="d-flex flex-column gap-2 p-2">
				<ng-template>
					<ng-content></ng-content>
					@if(buttonText()){
					<common-button-row [center]="true">
						<button class="common-collapse-btn btn btn-primary btn-large"
							(click)="accordion.collapse(header())">{{
							buttonText()}}</button>
					</common-button-row>
					}
				</ng-template>
			</div>
		</div>
	</div>
</div>